import React from 'react';
import { Container, Row, Col, Input, Label } from 'reactstrap';

class DropDownTextField extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'isDisplayingDropDown': false
        }
    }

    createRows(values, onClickRow) {
        return values.map((value, index) =>
            <Row onClick={(e) => {
                onClickRow(value, index)
                this.setState({
                    'isDisplayingDropDown': false
                })
            }}><Col><Label>{value}</Label></Col></Row>
        )
    }

    sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    render() {
        return <div
                onFocus={(e) => this.setState({ 'isDisplayingDropDown': true })}
                onBlur={(e) => {
                    this.sleep(300).then(() => {
                        this.setState({ 'isDisplayingDropDown': false })
                    })
                }}
            >
            <Input
                value={this.props.value}
                onChange={this.props.onChange}/>
            <Container 
                className='DropDownTextField'
                style={{
                'visibility':
                    this.state.isDisplayingDropDown &&
                    this.props.values.length > 0 &&
                    (this.props.value.length > 1 || this.props.alwaysDisplayValues) ?
                    'visible' : 'hidden',
            }}>{this.createRows(this.props.values, this.props.onClickRow)}
            </Container>
        </div>
    }
}

export default DropDownTextField
